import { CameraIcon } from 'shared-widget-components/src/components/Icons';
import { CarouselImages } from '../../../hooks/useCarouselImageRetriever';

/**
 * SlideImagePlaceholder component
 * this component is responsible for rendering the placeholder of the carousel if there is no image
 * @param image - image url
 * @returns SlideImagePlaceholder component
 */

export const SlideImagePlaceholder = ({ image }: { image: CarouselImages }) => {
  return (
    <div key={image.url} className='w-full min-[350px]:h-[210px] sm:h-[453px]'>
      <div className='w-full h-full bg-gray-300 flex flex-col items-center justify-center text-center'>
        <CameraIcon />
        <p className='text-[16px]'>Ezen a sliden még nem található kép</p>
      </div>
    </div>
  );
};
